function SiteFooter() {
  return (
    <footer className="border-t border-brand-petal/80 bg-white/70">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-8 text-sm text-brand-text/80 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p>6301 Grayson Rd Suite A-131, Harrisburg, PA 17111</p>
        <p>Mon-Sat: 8am-5pm | Sunday: Closed</p>
      </div>
    </footer>
  );
}

export default SiteFooter;